import React from 'react';

const isPhoneNumber = (value, isEmpty) => {
  const phoneNumberRegex = /^(?:\+?84|0)(?:\d){9}$/;
  return phoneNumberRegex.test(value);
};

const isEmail = (value, isEmpty) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};

const useValidate = () => {
  return {
    isPhoneNumber,
    isEmail,
  };
};

export default useValidate;
